import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TrustBar from '../../components/feature/TrustBar';
import ProcessSection from '../../components/feature/ProcessSection';
import WhyChooseUs from '../../components/feature/WhyChooseUs';
import ServiceAreasSection from '../../components/feature/ServiceAreasSection';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQSection from '../../components/feature/FAQSection';
import FinalCTASection from '../../components/feature/FinalCTASection';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import ServicesOverview from './components/ServicesOverview';
import AIAnswerBlock from './components/AIAnswerBlock';
import { homepageFaqs } from '../../mocks/faq';

export default function HomePage() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <StatsBar />
        <ServicesOverview />
        <AIAnswerBlock />
        <ProcessSection />
        <WhyChooseUs />
        <ServiceAreasSection />
        <TestimonialsSection />
        <FAQSection faqs={homepageFaqs} />
        <FinalCTASection />
      </main>
      <Footer />
    </>
  );
}
